import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type { Trigger } from 'modules/automations/store/models/Trigger'

interface Props {
  enabled: boolean
  selected: Trigger | null | undefined
  setContent: (content: string) => void
  creatingAutomation: boolean
}

const CreateButton = ({
  enabled,
  creatingAutomation,
}: {
  enabled: boolean
  creatingAutomation: boolean
}) => {
  return (
    <Button disabled={!enabled || creatingAutomation} submit>
      {i18n.t('automations.new.submit')}
    </Button>
  )
}

const NextButton = ({
  selected,
  setContent,
  setRepeatDetails,
}: {
  selected: Trigger | null | undefined
  setContent: (content: string) => void
  setRepeatDetails: (details: boolean) => void
}) => {
  return (
    <Button
      onClick={() => {
        setContent(selected?.attributes.slug ?? '') // TODO: Review this default
        setRepeatDetails(true)
      }}
    >
      {i18n.t('automations.new.next')}
    </Button>
  )
}

const BackButton = ({
  setContent,
  setRepeatDetails,
}: {
  setContent: (content: string) => void
  setRepeatDetails: (details: boolean) => void
}) => {
  return (
    <Button
      onClick={() => {
        setContent('main')
        setRepeatDetails(false)
      }}
      type="secondary"
    >
      {i18n.t('automations.new.back')}
    </Button>
  )
}

const Footer = ({ enabled, selected, setContent, creatingAutomation }: Props) => {
  const [repeatDetails, setRepeatDetails] = React.useState(false)

  if (repeatDetails) {
    return (
      <>
        <BackButton setRepeatDetails={setRepeatDetails} setContent={setContent} />
        <CreateButton enabled={enabled} creatingAutomation={creatingAutomation} />
      </>
    )
  }

  if (selected && selected.recurrentNeedsMoreConfig) {
    return (
      <NextButton setRepeatDetails={setRepeatDetails} setContent={setContent} selected={selected} />
    )
  }

  return <CreateButton enabled={enabled} creatingAutomation={creatingAutomation} />
}

export default Footer
